(() => {
  /* BEZELOR cart promo code box (markup: sections/main-cart-footer.liquid, styles: assets/bezelor-cart-x.css).
     Codes are checked by Shopify itself: the code is put on the cart with /cart/update.js and the cart that comes back says whether it applies.
     Nothing is shown as applied unless Shopify says so. If it does not apply, the code is taken off again and the reason is shown.
     The 2% quick checkout bonus (QUICKCHECKOUT2) combines with every discount, so it always stays on the cart and has no remove button.
     The BEZELOR codes (£5 to £30 off) are one per order: a second one is refused here.
     Two codes that Shopify will not combine are never swapped silently: the new code is refused and the cart is left as it was. */
  if (window.__bzxPromo) return;
  window.__bzxPromo = true;

  const BONUS = 'QUICKCHECKOUT2';
  /* What is known about the store's codes (shop currency GBP), mirrored from Shopify admin. Used only to explain a refusal. */
  const RULES = {
    BEZELOR5: { min: 50 },
    BEZELOR10: { min: 100 },
    BEZELOR20: { min: 150 },
    BEZELOR30: { min: 200 }
  };
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const lc = (v) => String(v || '').trim().toLowerCase();
  const family = (c) => !!RULES[String(c || '').toUpperCase()];
  const getCart = () => fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => r.json());
  const post = (path, body) => fetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());
  const money = (cents, cart) => {
    const cur = (cart && cart.currency) || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  };
  const rate = (cart) => {
    const r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    if (cart && cart.currency === 'GBP') return 1;
    return r > 0 ? r : 1;
  };
  const promoCodes = (cart) => (cart.discount_codes || []).filter((d) => d.code && lc(d.code) !== lc(BONUS));
  const appliedPromos = (cart) => promoCodes(cart).filter((d) => d.applicable !== false);
  const working = (cart) => (cart.discount_codes || []).filter((d) => d.code && d.applicable !== false).map((d) => d.code);

  /* Redraw the items and summary from the server, the same sections the theme redraws itself */
  const refreshSections = async () => {
    const itemsEl = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    const list = [['main-cart-items', itemsEl && itemsEl.dataset.id], ['main-cart-footer', footer && footer.dataset.id]].filter((x) => x[1]);
    if (!list.length) return;
    const data = await fetch(root() + '?sections=' + list.map((x) => x[1]).join(','), { cache: 'no-store' }).then((r) => r.json());
    list.forEach(([id, sid]) => {
      const el = document.getElementById(id);
      const target = el && el.querySelector('.js-contents');
      const src = new DOMParser().parseFromString(data[sid] || '', 'text/html').querySelector('.js-contents');
      if (target && src) target.innerHTML = src.innerHTML;
    });
  };

  const box = () => document.querySelector('[data-bzx-promo]');
  const parts = () => {
    const b = box();
    return b && { b, toggle: b.querySelector('.bzx-promo__toggle'), form: b.querySelector('.bzx-promo__form'), input: b.querySelector('.bzx-promo__input'), apply: b.querySelector('.bzx-promo__apply'), msg: b.querySelector('.bzx-promo__msg') };
  };
  const say = (text, kind) => {
    const p = parts();
    if (!p) return;
    if (!text) { p.msg.hidden = true; p.msg.textContent = ''; p.msg.removeAttribute('data-kind'); p.b.classList.remove('has-error', 'has-ok'); return; }
    p.msg.textContent = text;
    p.msg.dataset.kind = kind;
    p.msg.hidden = false;
    p.b.classList.toggle('has-error', kind === 'error');
    p.b.classList.toggle('has-ok', kind === 'ok');
  };
  const open = (on) => {
    const p = parts();
    if (!p) return;
    p.b.classList.toggle('is-open', on);
    p.toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
  };
  const busy = (on) => {
    const p = parts();
    if (!p) return;
    p.b.classList.toggle('is-busy', on);
    p.input.disabled = on;
    p.apply.disabled = on;
    p.apply.textContent = on ? 'Checking' : 'Apply';
  };

  /* Amount Shopify took off for one code */
  const savedBy = (cart, code) => {
    let total = 0;
    (cart.cart_level_discount_applications || []).forEach((a) => { if (lc(a.title) === lc(code)) total += a.total_allocated_amount || 0; });
    (cart.items || []).forEach((it) => (it.discounts || []).forEach((d) => { if (lc(d.title) === lc(code)) total += d.amount || 0; }));
    return total;
  };

  /* Why Shopify did not apply a code: only reasons that can be known are given */
  const reasonFor = (code, cart, others) => {
    const rule = RULES[String(code).toUpperCase()];
    if (!rule) return 'Invalid promo code.';
    if (rule.ends && Date.parse(rule.ends) < Date.now()) return 'This code has expired.';
    if (rule.min) {
      const need = Math.round(rule.min * rate(cart) * 100);
      const have = cart.items_subtotal_price || 0;
      if (have < need) return 'Spend ' + money(need - have, cart) + ' more to unlock this code.';
    }
    if (others.length) return 'This code cannot be combined with your current offer.';
    return 'This code cannot be applied to your current cart.';
  };

  const changed = () => document.dispatchEvent(new CustomEvent('bz:promo-changed'));

  let running = false;
  const apply = async (raw) => {
    const code = String(raw || '').replace(/\s+/g, '').trim();
    if (!code) { say('Enter a promo code.', 'error'); return; }
    if (running) return;
    running = true;
    busy(true);
    say('');
    try {
      const before = await getCart();
      if (!before.item_count) { say('Your cart is empty.', 'error'); return; }
      if ((before.discount_codes || []).some((d) => lc(d.code) === lc(code))) {
        say(lc(code) === lc(BONUS) ? 'Your 2% quick checkout bonus is already on your cart.' : code.toUpperCase() + ' is already on your cart.', 'error');
        return;
      }
      if (family(code) && appliedPromos(before).some((d) => family(d.code))) { say('This code cannot be combined with your current offer.', 'error'); return; }
      /* every code that already works stays on, the 2% bonus included */
      const keep = working(before);
      const after = await post('cart/update.js', { discount: keep.concat(code).join(',') });
      const entry = (after.discount_codes || []).find((d) => lc(d.code) === lc(code));
      /* a code that worked before but no longer does was pushed out by the new one: Shopify does not combine them */
      const pushedOut = keep.some((k) => { const e = (after.discount_codes || []).find((d) => lc(d.code) === lc(k)); return !e || e.applicable === false; });
      if (entry && entry.applicable !== false && !pushedOut) {
        await refreshSections().catch(() => {});
        const saved = savedBy(after, entry.code);
        say(saved > 0 ? 'Code applied — you saved ' + money(saved, after) + '!' : 'Code applied.', 'ok');
        const p = parts();
        if (p) p.input.value = '';
        changed();
      } else {
        const why = reasonFor(code, after, appliedPromos(before));
        /* put the cart back exactly as it was, bonus included */
        await post('cart/update.js', { discount: keep.join(',') }).catch(() => {});
        await refreshSections().catch(() => {});
        say(pushedOut && entry && entry.applicable !== false && !/^Spend|expired|Invalid/.test(why) ? 'This code cannot be combined with your current offer.' : why, 'error');
        changed();
      }
    } catch (e) {
      say('We could not check that code. Please try again.', 'error');
    } finally {
      running = false;
      busy(false);
    }
  };

  const remove = async (code) => {
    if (running || lc(code) === lc(BONUS)) return;
    running = true;
    try {
      const cart = await getCart();
      const left = working(cart).filter((c) => lc(c) !== lc(code));
      await post('cart/update.js', { discount: left.join(',') });
      await refreshSections().catch(() => {});
      open(true);
      say('Code ' + String(code).toUpperCase() + ' removed.', 'ok');
      changed();
    } catch (e) {
      say('We could not remove that code. Please try again.', 'error');
    } finally {
      running = false;
    }
  };

  document.addEventListener('click', (event) => {
    const t = event.target.closest && event.target.closest('.bzx-promo__toggle');
    if (t) {
      const p = parts();
      const next = !p.b.classList.contains('is-open');
      open(next);
      if (next) setTimeout(() => p.input.focus({ preventScroll: true }), 120);
      return;
    }
    const x = event.target.closest && event.target.closest('[data-bzx-remove]');
    if (x) { event.preventDefault(); remove(x.dataset.bzxRemove); }
  });
  document.addEventListener('submit', (event) => {
    if (!event.target.matches || !event.target.matches('.bzx-promo__form')) return;
    event.preventDefault();
    const p = parts();
    apply(p.input.value);
  });
  document.addEventListener('input', (event) => {
    if (event.target.matches && event.target.matches('.bzx-promo__input')) {
      const p = parts();
      if (p && !p.msg.hidden) say('');
    }
  });
})();
